<template>
    <div>
        <se-field :label-text="labelText">
          <se-textarea class="resize-none h-[72px]" v-model="value" :placeholder="labelText"/>
        </se-field>
        <div class="w-full flex justify-between mt-16">
          <se-button type="tertiary" size="small" class="w-full" :disabled="loading" @click="cancelClicked">
            Cancel
          </se-button>
          <se-button type="primary" size="small" class="w-full" :loading="loading" @click="emit('add', value)">
            Save
          </se-button>
        </div>
    </div>
</template>

<script setup lang="ts">
import {withDefaults, computed} from 'vue';
import SeField from "@/src/shared/ui-kit/field/Field.vue";
import SeButton from "@/src/shared/ui-kit/button/Button.vue";
import SeTextarea from "@/src/shared/ui-kit/textarea/Textarea.vue";

const props = withDefaults(defineProps<{
  labelText: string,
  modelValue?: string,
  activeForm?: boolean,
  loading?: boolean,
}>(), {
  activeForm: false,
  loading: false,
  modelValue: '',
});

const emit = defineEmits(['cancel', 'add', 'update:modelValue']);

const value = computed<string>({
  get() {
    return props.modelValue;
  },
  set(val: string) {
    emit('update:modelValue', val);
  },
});

const oldValue: string = value.value;

const cancelClicked = () => {
  value.value = oldValue
  emit('cancel')
}

</script>

<script lang="ts">
export default {
  name: 'SeNoteForm',
};
</script>

<style scoped lang="scss">

</style>